import { createContext } from 'react';
import { SubAccount } from 'vopay';
import { SubAccountStatus } from './SubAccountSearchForm';
import { SubAccountListHostProps, SubAccountListState, SubAccountsListsShow } from './types';

/**
 * Everything the feature's internal parts (SubAccountList.Table) read from the root: the host props, the
 * host-facing list state, and the list plumbing the root owns — the URL-driven filters, the pagination and the
 * fetched rows — so the table can be unmounted (org-chart view) and remounted without refetching, exactly as
 * the old page kept this state above its conditionally-rendered Card.
 */
export type SubAccountListContextValue = SubAccountListHostProps &
  SubAccountListState & {
    filters: { status: SubAccountStatus; currency: string; country: string; searchTerm: string };
    search: (values: { searchTerm: string; status: SubAccountStatus; currency: string; country: string }) => void;
    pagination: { pageCount: number; pageIndex: number; setPageIndex: (pageIndex: number) => void };
    subAccounts: SubAccount[];
    /** The fetched sub-accounts flattened to one row per currency balance (mapBalances), computed once. */
    mappedSubAccounts: SubAccountsListsShow[];
    /** True while the filter / page fetch is in flight; the table renders a skeleton in its place. */
    isLoadingSubAccounts: boolean;
    /**
     * Re-run the list fetch, with every active filter, so a row mutation is reflected. Throws on !Success like
     * every Direct-Pattern fetch.
     */
    refetchSubAccounts: () => Promise<unknown>;
  };

export const SubAccountListContext = createContext<SubAccountListContextValue | null>(null);
